export default __webpack_public_path__ + "static/media/part_logo8.4214998b.png";